import { setCookie, getCookie } from "./cookie"

export class FormTool {

	static _b_mm = false;
	static _b_mc = false;
	static _b_ic = false;
	static _b_tb = false;
	static _b_ico = null;
	static _b_tp = false;

	static calcHPI = () => {
		let thpi = 100;
		if (!FormTool._b_tb) {
			if (!FormTool._b_mm) {thpi=thpi-10} 
			if (!FormTool._b_mc) {thpi=thpi-10} 
			if (!FormTool._b_ic) {thpi=thpi-10}
		}
		if (!FormTool._b_ico) {thpi=thpi-10} 
		if (!FormTool._b_tp) {thpi=thpi-10} 
		return thpi;
	}

	static init = () => {
		try {
			let forms = document.forms;
			if (forms) {
				//console.log('init with ' + forms.length + ' forms.')
				FormTool._b_ico = getCookie('fcode');
				setTimeout(function() {
					FormTool._b_tp = true;
				}, 1500);
				let inputs = document.querySelectorAll('label, input.form-control, select')
				if (inputs) {
					for (let i = 0; i < inputs.length; i++) {
						inputs[i].addEventListener('mousedown', function(e) {
							if (!FormTool._b_ic) {FormTool._b_ic = true;}
						});
					}
				}
				window.addEventListener('mousedown', function (e) {
					if (!FormTool._b_mc) {FormTool._b_mc = true;}
				});
				window.addEventListener('mousemove', function (e) {
					if (!FormTool._b_mm) {FormTool._b_mm = true;}
				});
				document.addEventListener('keydown', function (e) {
					if (e.key == 'Tab') {
						if (!FormTool._b_tb) {FormTool._b_tb = true;}
					}
				});
				for (let i = 0; i < forms.length; i++) {
					let thisform = forms[i];
					let _cidi = forms[i].querySelector("input[name='vlt']");
					if (_cidi) {
						forms[i].addEventListener('submit', function(e) {
							e.preventDefault();
							let hpi = document.getElementById('bonsait-hpi');
							if (hpi) {
								hpi.value = FormTool.calcHPI();
							} else {
								hpi = document.createElement('input');
								hpi.id = "bonsait-hpi";
								hpi.type = 'hidden';
								hpi.name = "hpi";
								hpi.value = FormTool.calcHPI();
								thisform.appendChild(hpi);
							}
							this.submit();
						});
					}
				};
			}
		} catch (error) {
			console.error(error)
		}
    }

	static deSpam = (id) => {
		try {
			let form = document.querySelector("#"+id);
			if (form) {
				form.addEventListener('submit', function(e) {
					e.preventDefault();
					let hpi = document.getElementById('bonsait-hpi');
					if (hpi) {
						hpi.value = FormTool.calcHPI();
					} else {
						hpi = document.createElement('input');
						hpi.id = "bonsait-hpi";
						hpi.type = 'hidden';
						hpi.name = "hpi";
						hpi.value = FormTool.calcHPI();
						form.appendChild(hpi);
					}
					this.submit();
				});
				//console.log('Form #' + id + ' despammed.')
			}
		} catch (error) {
			console.error(error)
		}
	}

}


